/* eslint-disable no-param-reassign */
import {
  InputHTMLAttributes,
  useEffect,
  useRef,
  CSSProperties,
  forwardRef,
  useImperativeHandle,
  ForwardedRef,
} from 'react';

import { useField } from '@unform/core';

import { Container, Label } from './styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label?: string;
  labelStyle?: CSSProperties;
}

const CheckBox = forwardRef(
  (
    { name, labelStyle, label, ...rest }: InputProps,
    innerRef?: ForwardedRef<HTMLInputElement>,
  ) => {
    const inputRef = useRef<HTMLInputElement>(null); // HTMLInputElement - vai dar ao inputRef as propriedades de um input

    useImperativeHandle<HTMLInputElement | null, HTMLInputElement | null>(
      innerRef,
      () => inputRef.current,
      [],
    );

    const { fieldName, defaultValue, registerField } = useField(name);

    useEffect(() => {
      registerField({
        name: fieldName,
        ref: inputRef,
        getValue: (ref) => {
          return ref.current.checked;
        },
        setValue: (ref, value) => {
          ref.current.checked = value;
        },
      });
    }, [defaultValue, fieldName, registerField]);

    return (
      <>
        <Container>
          <input
            defaultValue={defaultValue}
            type="checkbox"
            ref={inputRef}
            {...rest}
          />
          <span />
        </Container>
        <Label style={labelStyle}>{label}</Label>
      </>
    );
  },
);

CheckBox.defaultProps = {
  label: '',
  labelStyle: {},
};

export default CheckBox;
